import React from 'react';
import {
    useQuery,
    QueryClient,
    QueryClientProvider,
} from 'react-query';
import axios from 'axios';
import './styles.scss';

const queryClient = new QueryClient();

export function StatsRabbitmq() {
    return (
        <QueryClientProvider client={queryClient}>
            <Page />
        </QueryClientProvider>
    );
}

function Page() {
    const { data, error } = useQuery({
        queryKey: ['queue-status'],
        refetchInterval: 10000,
        async queryFn() {
            const { data: d } = await axios.get('/api/v2/adminPanel/queue-status?filter=cargo,vessel,requests');
            return d.data;
        },
    });

    if (error) {
        return <div className="error-message">Error fetching ack rate: {error.message}</div>;
    }
    
    const cargoQueues = data ? data.filter(item => item.queue.includes('cargo-')) : [];
    const vesselQueues = data ? data.filter(item => item.queue.includes('vessel-')) : [];
    const tcQueues = data ? data.filter(item => item.queue.includes('tc-')) : [];
    const salesQueues = data ? data.filter(item => item.queue.includes('sales-')) : [];
    const otherQueues = data ? data.filter(item => 
        !item.queue.includes('cargo-') && !item.queue.includes('vessel-') &&
        !item.queue.includes('tc-') && !item.queue.includes('sales-')) : [];

    const sort = {
        '-to-annotate': 1,
        '-completed': 2,
        '-requests': 3,
        '--requests-result': 4,
    };

    const getPriority = (queueName) => {
        let priority = Infinity;
        Object.keys(sort).forEach((suffix) => {
            if (queueName.endsWith(suffix)) {
                priority = sort[suffix];
            }
        });
        return priority;
    };
    
    const sortQueues = queues => queues.sort((a, b) => getPriority(a.queue) - getPriority(b.queue));
        
    const sortedCargoQueues = sortQueues(cargoQueues);
    const sortedVesselQueues = sortQueues(vesselQueues);
    const sortedTcQueues = sortQueues(tcQueues);
    const sortedSalesQueues = sortQueues(salesQueues);

    const RateBlock = ({ item }) => (
        <div className="rate-block">
            <div className="rate-details">
                <span className="label">Queue:</span>
                <span className="value">{item.queue}</span>
            </div>
            <div className="rate-details">
                <span className="label">In work:</span>
                <span className="value">{item.total}</span>
            </div>
            <div className="rate-details">
                <span className="label">Work Rate:</span>
                <span className="value">{item.ackRate.toFixed(2)}/s</span>
            </div>
            <div className="rate-details">
                <span className="label">Workers:</span>
                <span className="value">{item.workers}</span>
            </div>
        </div>
    );

    return (
        <div className="acknowledgment-rates">
            <h1 className="title">RabbitMQ Acknowledgment Rates</h1>

            {sortedCargoQueues.length > 0 && (
                <div className="group">
                    <h2>Cargo Queues</h2>
                    <div className="rates-container">
                        {sortedCargoQueues.map((item, index) => (
                            <RateBlock key={index} item={item} />
                        ))}
                    </div>
                </div>
            )}

            {sortedVesselQueues.length > 0 && (
                <div className="group">
                    <h2>Vessel Queues</h2>
                    <div className="rates-container">
                        {sortedVesselQueues.map((item, index) => (
                            <RateBlock key={index} item={item} />
                        ))}
                    </div>
                </div>
            )}

            {sortedTcQueues.length > 0 && (
                <div className="group">
                    <h2>Tc Queues</h2>
                    <div className="rates-container">
                        {sortedTcQueues.map((item, index) => (
                            <RateBlock key={index} item={item} />
                        ))}
                    </div>
                </div>
            )}

            {sortedSalesQueues.length > 0 && (
                <div className="group">
                    <h2>Sales Queues</h2>
                    <div className="rates-container">
                        {sortedSalesQueues.map((item, index) => (
                            <RateBlock key={index} item={item} />
                        ))}
                    </div>
                </div>
            )}

            {otherQueues.length > 0 && (
                <div className="group">
                    <h2>Other Queues</h2>
                    <div className="rates-container">
                        {otherQueues.map((item, index) => (
                            <RateBlock key={index} item={item} />
                        ))}
                    </div>
                </div>
            )}

            {cargoQueues.length === 0 && vesselQueues.length === 0 && otherQueues.length === 0 && (
                <div className="no-data">No data available</div>
            )}
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/components/Statistics/Queues/Page.jsx